/**
 * keyEscape, escape key close details element
 * @param {object} event
 * @returns
 *
 */
let observerOptions = {
	// root: this.parentElement,
	// rootMargin: "200px 0px 200px 0px",
	threshold: [0, 0.3] // fire callback when not visible, and visible 30%
};

const checkMeasure = (observerOptions.threshold[1]) ? observerOptions.threshold[1] : observerOptions.threshold[0];

const observerCallback = (entries, observer) => {

	entries.forEach((entry) => {

		/** --- onViewportEnter --- */
		if(entry.intersectionRatio >= checkMeasure && entry.isIntersecting) {

			if(entry.target.hasEntered === false || !entry.target.hasEntered) entry.target.dispatchEvent(window.Zero.dispatches.enter);

			entry.target.hasEntered = true;
		}

		/** --- onViewportExit --- */
		if(!entry.isIntersecting && entry.target.hasEntered === true) {

			if(entry.target.resetOnExit === true) entry.target.hasEntered = false;

			entry.target.dispatchEvent(window.Zero.dispatches.exit);
		}
	});
};

export const setIntersectionObserver = () => {
	return new IntersectionObserver(observerCallback, observerOptions);
}
